module.exports = __webpack_public_path__ + "static/media/Etiquetas5.b43abbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancEtiquetas/Etiquetas5.png
// module id = 2258
// module chunks = 0